import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ConfigService } from '@services/config/config.service';
import {ChangedDocumentService} from 'formbird-services';
import {SearchResultsProcessor} from '@formbird/shared';
import {SclMappingFunctionsService} from '../../../../formbird-mapping/src/lib/scl-mapping-functions.service';
import {sclHandlebars} from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import {SclMapConstantService} from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import {SclMapViewsService} from '../../../../formbird-mapping/src/lib/scl-map-views.service';
import {SclMapRulesInterfaceService} from '../../../../formbird-mapping/src/lib/scl-map-rules-interface.service';
import {FormbirdInjectorService} from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';

import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {AddressMapComponentDefinition} from './address-map.component.definition';
import {HttpService} from '../../../../formbird-mapping/src/lib/http.service';
import {isEqual, cloneDeep} from 'lodash';
import {HttpClient} from '@angular/common/http';
import { NotificationService } from '../../../../formbird-services/src/lib/services/notification/notification.service';
import { MapLibraryName, MapComponentName } from '../../../../formbird-mapping/src/lib/map-library';

const INITIALMAPVIEW_KEYWORDS = {
  FILTER: 'filter',
  LAYERS: 'layers',
  ALL: 'all',
  MAP: 'map',
  NONE: 'none'
}

@Component({
  templateUrl: './address-map.component.html',
  styleUrls: [
    './address-map.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressMapComponent extends AbstractComponent<AddressMapComponentDefinition> implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('tooltipInfo', { static: false }) tooltipInfo: ElementRef;
  @ViewChild('radioPopupInfo', {static: false}) radioPopupInfo: ElementRef;
  @ViewChild('info', {static: false}) divInfo: ElementRef;
  @ViewChild('info1', {static: false}) divInfo1: ElementRef;
  @ViewChild('loadingMessageItem', {static: false}) loadingMessageItem: ElementRef;
  @ViewChild('loadingMessageIcon', {static: false}) loadingMessageIcon: ElementRef;

  // service
  loggedInUserService: any;

  //
  disableSave;

  //
  mapFunc;
  mapLibName = MapLibraryName.OPEN_LAYER;
  disableMouseWheel = false;
  initialMapView = INITIALMAPVIEW_KEYWORDS.FILTER;
  selection: any = {};
  initialZoomChange = 0;
  mapParameters;
  addressField;
  isDisplayImage;
  currentSelected = [];
  selectMultiple;
  previousSelectedFeature;
  isLoading = false;
  allowSearch = true;
  searchType;
  layerIds = [];
  layers;
  defaultLat;
  defaultLon;
  defaultZoom;
  googleKey = null;
  zoomFloor;
  queryDelay = 5; lstQuery = []; isSearchLayer = false; objSearchByPosition; // 14465
  mapId;
  mapHeight;
  multipleSelection;
  toolTipInterval;
  toolTipTimeout = 2;
  toolTipZIndex = 100;
  mouseX = 0;
  mouseY = 0;
  mouseStopInterval;
  pixelPopup;
  lastEvt = null;
  isPopoverOpen;
  currentPopover;
  focusPopup = false;
  infoPosition = {left: '0px', top: '0px'};
  mapCenter;
  tooltipPosition;
  controls = [];
  tooltipText;
  countGeoJson = 0; totalSearchCount = 0;
  multiple = false;
  countQueries; countFinishSearch;
  searchByPositionCountQuery; searchByPositionCountFinishSearch;
  searchByLayerCountFinishSearch; searchByLayerCountQuery;
  countFit = 0;
  xMin; yMin; xMax; yMax;
  outstandingFilter = '';

  oldValue;
  oldValueLayers;
  isToolTipScroll; isRadioPopupScroll; // 15336
  infoRadioPosition; keyName; isPopupRadioOpen = false; postList: any = []; clusterMarkersClicked = []; allowSelectAsset; // 15251
  isMapReady; countCheckMapReady = 0; limitCheckMapReady = 20; // 15714
  nonSelectVisualItemCounter;
  intervalWaitForLoadAssetImage = null; countWaitForLoadAssetImage = 0;
  limitWaitForLoadAssetImage = 20; assetFitCount = 500;
  maxQueryReturnResults = 10000; assetLoaded = 0; assetTotal = 0; isLoadingAsset = false; isLoadingIconAsset = false;
  filterLayerIndex = -1;
  disableHandlebars = false;
  currentBounds = null; // 17453
  countLoadAssetProcess = 0;
  testCountAsset = 0;
  divWrapper: any;
  loadingMessageItemMarginTop = -30;
  loadingMessageIconMarginTop = -30;
  hasBoundingBox = true;
  validInitialMapViewValues = [
    INITIALMAPVIEW_KEYWORDS.ALL,
    INITIALMAPVIEW_KEYWORDS.MAP,
    INITIALMAPVIEW_KEYWORDS.FILTER,
    INITIALMAPVIEW_KEYWORDS.LAYERS,
    INITIALMAPVIEW_KEYWORDS.NONE];
  private searchClientService: any;

  constructor(
    public httpService: HttpService,
    public cdRef: ChangeDetectorRef,
    protected componentSetupService: ComponentSetupService,
    protected changedDocumentService: ChangedDocumentService,
    private sclUtilMapService: SclUtilMapService,
    private sclMapViews: SclMapViewsService,
    private configService: ConfigService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclMapRulesInterfaceService: SclMapRulesInterfaceService,
    private httpClient: HttpClient,
    private notificationService: NotificationService,
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.sclMapRulesInterfaceService.init(formbirdInjectorService, changedDocumentService, this.subs);
    this.searchClientService = this.formbirdInjectorService.get('SearchClientService');

    this.mapFunc = new SclMappingFunctionsService(httpClient,cdRef, notificationService);
    this.mapFunc.getToolTips = this.getToolTips.bind(this);
    this.mapFunc.createNewFeature = this.createNewFeature.bind(this);
    this.mapFunc.updateExistedFeature = this.updateExistedFeature.bind(this);
    this.mapFunc.finishSearchAsync = this.finishSearchAsync.bind(this);
  }

  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);
    this.keyName = this.fieldName + this.template.documentId;
    this.disableSave = false;
    if (!(typeof this.componentDefinition.disableSave === 'undefined' || this.componentDefinition.disableSave === null)) {
      this.disableSave = this.componentDefinition.disableSave;
    }

    if (!(typeof this.componentDefinition.disableMouseWheel === 'undefined' || this.componentDefinition.disableMouseWheel === null)) {
      this.disableMouseWheel = this.componentDefinition.disableMouseWheel;
    }
    if (!(typeof this.componentDefinition.initialMapView === 'undefined' || this.componentDefinition.initialMapView === null)) {
      this.initialMapView = this.componentDefinition.initialMapView;
    }
    if (this.validInitialMapViewValues.indexOf(this.initialMapView) < 0) {
      this.initialMapView = INITIALMAPVIEW_KEYWORDS.FILTER;
    }
    this.searchType = this.initialMapView;

    if (!(typeof this.componentDefinition.selection === 'undefined' || this.componentDefinition.selection === null)) {
      this.selection = this.componentDefinition.selection;
    }
    if (!(typeof this.componentDefinition.initialZoomChange === 'undefined' || this.componentDefinition.initialZoomChange === null)) {
      this.initialZoomChange = this.componentDefinition.initialZoomChange;
    }
    this.mapFunc.pageSize = 50;
    if (!(typeof this.componentDefinition.queryPageSize === 'undefined' || this.componentDefinition.queryPageSize === null)) {
      this.mapFunc.pageSize = this.componentDefinition.queryPageSize;
    }
    if (!(typeof this.componentDefinition.mapParameters === 'undefined' || this.componentDefinition.mapParameters === null)) {
      this.mapParameters = this.componentDefinition.mapParameters;
    }
    if (!(typeof this.componentDefinition.addressField === 'undefined' || this.componentDefinition.addressField === null)) {
      this.addressField = this.componentDefinition.addressField;
    } else {
      this.addressField = this.componentDefinition.geoJsonField;
    }

    if (!(typeof this.componentDefinition.popupDisplayImageFileNo96 === 'undefined'
     || this.componentDefinition.popupDisplayImageFileNo96 === null)) {
      this.isDisplayImage = this.componentDefinition.popupDisplayImageFileNo96;
    }
    if (!(typeof this.componentDefinition.queryDelay === 'undefined' || this.componentDefinition.queryDelay === null)) {
      this.queryDelay = this.componentDefinition.queryDelay;
    }
    if (!(typeof this.componentDefinition.selectionMode === 'undefined' || this.componentDefinition.selectionMode === null)
     && this.componentDefinition.selectionMode === 'multiple') {
      this.multiple = true;
    }

    if (!(typeof this.componentDefinition.maxQueryReturnResults === 'undefined' || this.componentDefinition.maxQueryReturnResults === null)) {
      this.maxQueryReturnResults = this.componentDefinition.maxQueryReturnResults;
    }

    if (!(typeof this.componentDefinition.assetFitCount === 'undefined' || this.componentDefinition.assetFitCount === null)) {
      this.assetFitCount = this.componentDefinition.assetFitCount;
    }

    if (!(typeof this.componentDefinition.systemMapLimit === 'undefined' || this.componentDefinition.systemMapLimit === null)) {
      this.mapFunc.systemMapLimit = this.componentDefinition.systemMapLimit;
    }

    if (!(typeof this.componentDefinition.disableHandlebars === 'undefined' ||
      this.componentDefinition.disableHandlebars === null)) {
        this.disableHandlebars = this.componentDefinition.disableHandlebars;
    }
    if (this.componentDefinition.showTiming) {
      this.mapFunc.showTiming = this.componentDefinition.showTiming;
    }// 15250

    if (this.componentDefinition.noBoundingBox) {
      this.hasBoundingBox = false;
    }


    this.sclMapRulesInterfaceService.setMapLayers(this.componentDefinition.componentName, this.componentDefinition.name
      , this.componentDefinition.layers, true, this.componentDefinition, this.document.documentId);


    sclHandlebars.initHandlebars(this.componentDefinition.handlebarsHelpers);
    this.mapFunc.contextParams = {
      doc: this.document,
      account: this.loggedInUserService.user.account,
      tpl: this.template,
      tplItem: this.componentDefinition
    };
    if (this.mapParameters) {
      this.defaultLat = this.mapParameters.defaultLat;
      this.defaultLon = this.mapParameters.defaultLon;
      this.defaultZoom = this.mapParameters.defaultZoom;
      if (this.mapParameters.EPSG) { this.mapFunc.EPSG = this.mapParameters.EPSG; }

      if (this.mapParameters.mapViews) {
        for (let i = 0; i < this.mapParameters.mapViews.length; i++) {
          if (this.mapParameters.mapViews[i].serverType === MapLibraryName.GOOGLE) {
            this.mapLibName = MapLibraryName.GOOGLE;
            this.googleKey = (typeof this.mapParameters.mapViews[i].apiKey === 'undefined'
            || this.mapParameters.mapViews[i].apiKey === null) ? null : this.mapParameters.mapViews[i].apiKey;
            if (this.googleKey == null) { console.error('Google map key is null'); }
            break;
          }
        }
      } else {
        this.mapParameters.mapViews = SclMapConstantService.DEFAULT_MAP_PARAMETERS.mapViews;
      }
    } else {
      this.mapParameters = SclMapConstantService.DEFAULT_MAP_PARAMETERS;
    }
    if (this.componentDefinition.layers) {
      let idx = 0;
      for (let i = this.componentDefinition.layers.length - 1; i > -1; i--) {
          idx++;
          // 1. logic heatmap
          let isHeatMap = false;
          if (this.componentDefinition.layers[i].type && this.componentDefinition.layers[i].type === 'heatmap') { isHeatMap = true; }
          this.mapFunc.layerAssets.push({query: this.componentDefinition.layers[i].filter + '_layer_' + idx, i: idx
          , isHeatMap: isHeatMap, layer: this.componentDefinition.layers[i]});

      }
    }
    if (this.componentDefinition.filter) {
      const filterIndex = this.defineFilterIndex();
      const filterInfo = this.sclUtilMapService.buildFilterObj(this.componentDefinition, this.addressField);
      this.mapFunc.layerAssets.push({query: this.componentDefinition.filter + '_filter_' + filterIndex, i: filterIndex, isHeatMap: false, layer: filterInfo});
      this.filterLayerIndex = filterIndex;
    }
    if (!(typeof this.componentDefinition.zoomFloor === 'undefined' || this.componentDefinition.zoomFloor === null)) {
      this.zoomFloor = !this.componentDefinition.zoomFloor;
    }

    this.mapHeight = '180';
    let height;
    if (this.componentDefinition.heightNum && this.componentDefinition.heightNum > 0 && !isNaN(this.componentDefinition.heightNum)) {
      height = 180 * this.componentDefinition.heightNum;
      const docHeight = document.body.scrollHeight;
      if (height > (docHeight - 180)) {
        height = docHeight - 180;
      }
      this.mapHeight = height;
    } else {
      height = 180;
      this.mapHeight = '180';
    }


    this.setupChangeDetection();

    const panelSub = this.broadcastService.on('panel-comp-def-updated').subscribe((data) => {
      if (data?.startKey < this.key && this.key < data?.endKey) {
        if (this.componentDefinition.visible !== false) {
          if (this.mapLibName === MapLibraryName.OPEN_LAYER && this.mapFunc) {
            this.mapFunc.showMap();
            console.log(`Show Map called.`);
          }
        }
      }
    });
    this.subs.add(panelSub);

    // begin listening 'eventList'
    const evtListSub = this.broadcastService.on('eventList').subscribe(data => {
      this.watchEventList(data);
    });
    this.subs.add(evtListSub);
    // end listening 'eventList'

  } // end ngOnInit

  onFieldValueChanged(fieldValue) {
    if (isEqual(this.fieldValue, fieldValue)) {
      return;
    }
    this.fieldValue = cloneDeep(fieldValue);
    this.watchDoc(fieldValue);
  }
  onComponentDefChanged(componentDefinition) {

    super.onComponentDefChanged(componentDefinition);

    if (((typeof componentDefinition.visible === 'undefined') || componentDefinition.visible === null)
      || componentDefinition.visible) {
      this.mapFunc.showMap();
    }

    this.mapFunc?.switchMapView(this.componentDefinition?.mapParameters?.showMapView, this.keyName);
      
  }

  setFieldActivation() {
    this.watchReadOnly();
    this.watchLayers(this.componentDefinition.layers);
    this.detectChanges();
  }

  ngAfterViewInit() {
    this.initMap();

  } // end ngAfterViewInit

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }

  initMap() {
    this.cdRef.detectChanges();

    this.mapFunc.divInfo = this.divInfo;
    this.mapFunc.divInfo1 = this.divInfo1;

    this.mapId = this.fieldName + 'gblMap';
    const targetMap = document.getElementById(this.mapId);
    this.mapFunc.targetMapElement = targetMap;
    this.divWrapper = document.getElementById( this.fieldName + 'address-map') ;

    // init map
    const self = this;
    this.mapFunc.initLib(this.mapFunc, this.mapLibName , {googleKey: this.googleKey}
      , async (mapObj) => {
      console.log(`****************** init map done ******************* `);
      this.mapFunc.mapObj = mapObj;
      this.mapFunc.multiLayers(this.mapParameters); // add multiple map views

      const ActionControl = function(ctrlOptions) {
        const options = ctrlOptions || {};

        const element = document.createElement('div');

        const controlElement = document.createElement('div');
        if (self.mapLibName === MapLibraryName.GOOGLE) {
          controlElement.className = 'gg-control radio-group ol-control custom-control';
        } else { controlElement.className = 'radio-group ol-control custom-control'; }

        self.addRadioButton(controlElement, 'S', true, (() => {
          return () => {
            self.changeMode(false);
          };
        })());
        self.addRadioButton(controlElement, 'M', false, (() => {
          return () => {
            self.changeMode(true);
          };
        })());

        if (self.componentDefinition.selectionMode && self.componentDefinition.selectionMode === 'user') {
            element.appendChild(controlElement);
        }

        self.mapFunc.addMapViewControl(element, self.keyName, self.layerIds);

        self.mapFunc.mapObj.addControl(this, element, options);
        self.mapFunc.mapObj.elementCtrl = controlElement;
      };
      this.mapFunc.mapObj.setupControl(ActionControl);
      this.controls.push(new ActionControl({}));


      if (this.selection.selectionImageFileNo) {
        let resource;
        try {
          resource = await this.mapFunc.getIcon(this.selection.selectionImageFileNo);
          this.selection.selectionImageFileNo = resource;
          let imageUrl = this.sclUtilMapService.handleImageFileNo(resource);
          await this.mapFunc.cacheImage(imageUrl);
        } catch(err) {
          console.log(`err getFileResource : ${err.message}`);
        }
      }

      await this.mapFunc.setupMap(this.mapFunc, {target: this.mapFunc.targetMapElement, disableMouseWheel : this.disableMouseWheel
        , divWrapper: this.divWrapper, defaultLon: this.defaultLon, defaultLat: this.defaultLat, defaultZoom: this.defaultZoom
        , formatGeoJSON: (this.mapLibName === MapLibraryName.GOOGLE ? this.document[this.fieldName] : null)
        , EPSG: this.mapFunc.EPSG
        , minResolution: this.mapParameters.minResolution, maxResolution: this.mapParameters.maxResolution
        , layerAssets : this.mapFunc.layerAssets
        , interactions: this.multipleSelection ? [this.selectMultiple] : []
        , controls: this.controls, style: MapComponentName.ADDRESS_MAP
        , mapId: this.mapId, selectionStyle: this.selection
        , setDirty : (this.mapLibName === MapLibraryName.OPEN_LAYER ? null : this.setDirty.bind(this))
        , singleSelectMode: (this.mapLibName === MapLibraryName.OPEN_LAYER ? null : this.singleSelectMode.bind(this))
        , initialZoomChange: this.initialZoomChange
        , onTilesLoaded: this.onMoveEnd.bind(this)
        , zoomFloor: this.zoomFloor
        // , updateWatchFieldsObj: {
        //    updateWatchFieldsLayer: this.updateWatchFieldsLayer
        //   , layers: this.componentDefinition.layers
        //   , layerAssets: this.mapFunc.layerAssets
        //   , searchLayerFunc: this.searchAssetLayerUpdate.bind(this)
        // } // 14164
        , watcherFunction: (doc) => {
          // 16772#0068539
          if (!isEqual(this.document, doc)) {
            this.document = doc;
            this.mapFunc.contextParams.doc = this.document;
          } else {
            console.log(`happenning watch document but new Value = old Value`);
          }
        }
        , componentDefinition : this.componentDefinition // 11618#c55242 : hasn't needed for angularJS version yet
        , configService: this.configService // 11618#c55242 : hasn't needed for angularJS version yet
        , setupTooltipUI: this.mapFunc.setupTooltipUI.bind(this.mapFunc)
        , singleSelectModeCluster: this.singleSelectModeCluster.bind(this) // 15251
        , clusterClick: this.clusterClick.bind(this) // 15251
        , systemMapLimit: this.mapFunc.systemMapLimit
        , disableHandlebars: this.disableHandlebars
      }, this.keyName);

      if (this.isMapReady == null) {
        this.isMapReady = setInterval( this.checkMapReady.bind(this), 200);
      }

      this.changeMode(this.multiple);
      if (this.mapLibName == MapLibraryName.GOOGLE) {
        this.mapFunc.mapObj.mapMoveEnd(this.onMoveEnd.bind(this));
      }
      

      this.mapFunc.mapObj.mapPointerMoveEvent( (evt) => {
        if (evt.dragging) {
            return;
        }

        this.lastEvt = evt;
        if (!this.mouseStopInterval && (!this.focusPopup || !this.currentPopover)) {
          this.mouseStopInterval = setInterval(() => {
            this.hasMouseStopped(evt);
          }, 450);

        }
      });

      this.mapWatchStop();
      // ** begin TO DO
      // let mapWatchStop = scope.$watch('map', function () {
      //   // stop the mapWatch because it only needs to be run once
      //   mapWatchStop();


      // });//end mapWatchStop
      // ** end TO DO

      this.mapFunc.mapObj.mapClickEvent((evt) => {
        if (this.disabled) { return; }
        if (this.mapLibName === MapLibraryName.GOOGLE) {
          this.singleSelectMode({pixel: evt.pixel, id: null});
        } else { this.singleSelectMode(evt.pixel); } // 13835
      }); // end map click event

      this.watchReadOnly();

    }, this.changedDocumentService, this.subs, this.document); // end initLib map
  }

  calculateLoadingMessageMarginTop(loadingMessageElement, wrapperMarginBottom) {
    const factor = loadingMessageElement.nativeElement.offsetHeight / 2;
    const marginTop = -(loadingMessageElement.nativeElement.offsetHeight
    + wrapperMarginBottom + factor);

    return marginTop;
  }

  setupLoaddingMessagePosition() {
    // setup margin top for loading message

    const style = this.divWrapper.currentStyle
     || window.getComputedStyle(this.divWrapper);
    const marginBottom = parseInt(style.marginBottom.replace('px', ''));

    this.loadingMessageItemMarginTop = this.calculateLoadingMessageMarginTop(
      this.loadingMessageItem, marginBottom
    );

    this.loadingMessageIconMarginTop = this.calculateLoadingMessageMarginTop(
      this.loadingMessageIcon, marginBottom
    );;

    this.cdRef.detectChanges();
  }

  defineFilterIndex() {
    let filterIndex = 1;
    if ( this.componentDefinition.layers && this.componentDefinition.layers.length > 0) {
      filterIndex = this.componentDefinition.layers.length + 1;
    }
    return filterIndex;
  }

  removeDuplicates(originalArray, prop) {
    const newArray = [];
    const lookupObject  = {};

    for (const i in originalArray) {
      if (originalArray.hasOwnProperty(i)) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
      }
    }
    for (const i in lookupObject) {
      if (lookupObject.hasOwnProperty(i)) {
        newArray.push(lookupObject[i]);
      }
    }
    return newArray;
  }
  updateDataToBeSaved(selectedAsset) {
    if (selectedAsset == null) { return; }
    // if (selectedAsset.length > 0){
    const items = [];
    selectedAsset.forEach((entry, i) => {
      const name = this.mapFunc.mapObj.getFeatureProperty(entry, 'name');
      let id = this.mapFunc.mapObj.getFeatureId(entry);
      if (id.indexOf('_') > -1) { id = id.split('_')[0]; }
      items.push({name: name, documentId: id});
    });


    const uniqueArray = this.removeDuplicates(items, 'documentId');
    if (!isEqual(this.fieldValue, uniqueArray)) {
      super.valueChanged(uniqueArray);
    }

  }
  setDirty(e) {
    if (this.mapLibName !== MapLibraryName.OPEN_LAYER) {
      this.currentSelected = e;
      // for(const i = 0; i < e.length; i++){
      //    currentSelected.push(e[i]);
      // }
    }

    this.updateDataToBeSaved(this.currentSelected);
  }
  changeMode(multipleSelection) {
    this.multipleSelection = multipleSelection;
    this.allowSelectAsset = multipleSelection;
    let isShow = true;
    if (multipleSelection) {
        isShow = true;
    } else {
        isShow = false;
    }
    this.mapFunc.mapObj.showLayer({ isShow: isShow, layerIndex: this.mapFunc.mapObj.layerIndexUser
      , currentSelected: this.currentSelected });
    this.mapFunc.mapObj.activeInteractionSelect(this.multipleSelection); // TO DO : 13835
    // updateDataToBeSaved(currentSelected);
  }
  disableTooltip() {
    clearInterval(this.toolTipInterval);
    this.toolTipInterval = null;
    this.previousSelectedFeature = undefined;
    this.isPopoverOpen = false;
    this.focusPopup = false;
    this.currentPopover = undefined;
    this.tooltipInfo.nativeElement.innerHTML = '';
    this.tooltipText = '';
    this.infoPosition = {left: '0px', top: '0px'};

    this.cdRef.detectChanges();
  }
  cancelTooltipTimeout(feature) {
    if (this.toolTipTimeout && this.toolTipInterval !== undefined) {
      clearInterval(this.toolTipInterval);
      this.toolTipInterval = undefined;
    }
  }
  scheduleTooltip(feature) {
    if (feature && this.toolTipInterval !== undefined) {
      this.toolTipInterval = setInterval( () => {
        this.disableTooltip();
        }, this.toolTipTimeout * 1000);
    }
  }
  setTooltipPosition(pixel) {
    this.isToolTipScroll = false;
    this.tooltipInfo.nativeElement.style.height = 'auto';

    const featureLeftPos = pixel[0];
    const featureTopPos = pixel[1] ;

    let tooltipWidth = this.divInfo.nativeElement.offsetWidth;
    let tooltipHeight = this.divInfo.nativeElement.offsetHeight;
    if (tooltipWidth === 0) { tooltipWidth = 200; }
    if (tooltipHeight === 0) { tooltipHeight = 60; }

    let left = featureLeftPos - tooltipWidth;
    let top = featureTopPos - tooltipHeight;
    if (left < 0) {
      left = 0;
    } else if (left > this.divWrapper.offsetWidth
       || ((left + this.divInfo.nativeElement.offsetWidth) > this.divWrapper.offsetWidth)) {
      left = left - this.divInfo.nativeElement.offsetWidth;
    }
    if (top < 0) { top = 0; }
    this.infoPosition.left = `${left}px`;
    this.infoPosition.top = `${top}px`;
    this.isPopoverOpen = true;
    this.cdRef.detectChanges();

  }
  displayFeatureInfo(pixel) {
    const obj = this.mapFunc.mapObj.getFeatureByPixel(pixel);
    if (obj == null) { return null; }
    const feature = obj.feature;
    if (feature == null) { return feature; }
    let shouldShow = false;
    this.pixelPopup = (this.mapLibName === MapLibraryName.OPEN_LAYER) ? pixel : pixel.pixel;
    const tooltip = this.mapFunc.mapObj.getFeatureProperty(feature, 'tooltip');
    if (tooltip) {
      // check popup is showing or not
      const isPopupShowed = false;

      if ((this.previousSelectedFeature === undefined || !isEqual(this.previousSelectedFeature, feature))
       && (!this.focusPopup || !isPopupShowed)) {
        this.cancelTooltipTimeout(feature);

        this.tooltipText = tooltip;
        this.tooltipInfo.nativeElement.innerHTML = tooltip;
        this.previousSelectedFeature = feature;
        shouldShow = true;
        this.cdRef.detectChanges();
        this.setTooltipPosition(this.pixelPopup);
      }

      if (!isPopupShowed && shouldShow) {
          $(this.mapFunc.divInfo).trigger('click');
          this.isPopoverOpen = true;
          const popover = $(this.mapFunc.divInfo.nativeElement)[0].querySelectorAll('div.ppover-inner')[0];
          this.currentPopover = popover;
          this.focusPopup = false;
          if (popover) {
            const lst = document.querySelectorAll('[content-exp="contentExp()"]');
            if (lst != null && lst.length > 0) {
              const item: any = lst[0];
              item.style.zIndex = this.mapFunc.mapObj.layerIndexTooltips;
            }
            popover.style.zIndex = this.mapFunc.mapObj.layerIndexTooltips;
            popover.onmouseover = () => {
              this.focusPopup = true;
              this.cancelTooltipTimeout(feature);
            };
            popover.onmouseout = () => {
              this.focusPopup = false;
              // scheduleTooltip(feature);
            };
          }
      }
    }

    return feature;
  }
  hasMouseStopped(evt) {

    const newMouseX = (this.mapLibName === MapLibraryName.OPEN_LAYER ? evt.originalEvent.x : evt.pixel[0] );
    const newMouseY = (this.mapLibName === MapLibraryName.OPEN_LAYER ? evt.originalEvent.y : evt.pixel[1] );

    if ((newMouseX === this.mouseX) && (newMouseY === this.mouseY)) {
      // stopped moving
      clearInterval(this.mouseStopInterval);
      this.mouseStopInterval = null;

      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {


        const evtPixel = this.mapFunc.mapObj.getEventByPixel(this.lastEvt.originalEvent);
        this.displayFeatureInfo(evtPixel);
      } else {
        this.displayFeatureInfo(evt);
      }

    }
    this.mouseX = newMouseX;
    this.mouseY = newMouseY;
  }
  getMapSize() {
    const mapSize = this.mapFunc.mapObj.getMapSize();

    if (mapSize) {
      const mapWidth = mapSize[0];
      const mapHeight = mapSize[1];
      this.mapCenter = {x: mapWidth / 2, y: mapHeight / 2};
    } else {
      console.log(`Coudn't get size of map to enable tooltips`);
    }
  }
  selectModeSingle(feature, isCluster) {
    let pixel = feature;
    if (isCluster) {
      const px = this.mapFunc.mapObj.convertLatLngToPixel(feature.getPosition());
      const id = this.mapFunc.mapObj.getFeatureId(feature);
      pixel = { id: id, pixel: px };
    }
    const f = this.displayFeatureInfo(pixel);
    if (f) {
      const pro = this.mapFunc.mapObj.getFeatureProperties(f, ['url', 'layerDisplayOnly']);
      const layerDisplayOnly = pro.layerDisplayOnly;
      let url = pro.url;
      if (!url) { return; }
      if (url.indexOf('_') > -1) { url = url.split('_')[0]; }
      if (url && !layerDisplayOnly) {
          window.open(url);
      } else { this.disableTooltip(); }
    } else {
      this.disableTooltip();
    }
  }
  selectModeMultiple(features, isCluster) {
    if (features.length > 0) {
      const selectFeatures = [];
      let hasChange = false;
      features.forEach((f, j) => {
        let fea = f;
        if (!isCluster) { fea = f.feature; }
        const feaId = this.mapFunc.mapObj.getFeatureId(fea);
        let isExist = false;

        if (this.currentSelected != null) {
            for (let i = this.currentSelected.length - 1; i > -1; i--) {
              const fId = this.mapFunc.mapObj.getFeatureId(this.currentSelected[i]);
              const fIndex = this.mapFunc.mapObj.getFeatureProperty(this.currentSelected[i], 'zIndex');
              if (fId === feaId && fIndex === this.mapFunc.mapObj.layerIndexUser ) {
                isExist = true;
                const p = this.mapFunc.mapObj.getFeatureProperties(fea, ['isCluster', 'zIndex']);
                const isCluster = p.isCluster; const zIndex = p.zIndex;
                if (isCluster && zIndex !== this.mapFunc.mapObj.layerIndexUser) {
                  this.mapFunc.mapObj.removeFeature(this.currentSelected[i], this.mapFunc.mapObj.layerIndexUser);
                } else {
                  this.mapFunc.mapObj.removeFeature(fea, this.mapFunc.mapObj.layerIndexUser);
                }
                this.currentSelected.splice(i, 1);
                hasChange = true;
                // this.setDirty(null);
              }
            }
        }
        if (!isExist) {
          const fClone = this.mapFunc.mapObj.featureClone(fea, this.mapFunc.mapObj.layerIndexUser);
          this.mapFunc.mapObj.addFeature(fClone, this.mapFunc.mapObj.layerIndexUser);
          if (isCluster) {
            selectFeatures.push({ feature: fClone } );

          } else {
            this.currentSelected.push(fClone);
            this.setDirty(null);
          }
        }
      });
      if (selectFeatures.length > 0 && isCluster) {
        if (this.mapLibName === 'gooogle') {
          this.mapFunc.mapObj.setSelectAssetCluster(selectFeatures);
        } else {
          this.mapFunc.mapObj.setSelectAssetCluster(selectFeatures, this.currentSelected);
          this.setDirty(this.currentSelected);
        }
      } else if (hasChange) {
        this.setDirty(this.currentSelected);
      }
    }
  }
  singleSelectMode(pixel) {
    if (this.multipleSelection) {
      let options = {};
      if (this.mapLibName === MapLibraryName.GOOGLE) {
        options = { feature: pixel};
      } else {
        options = { pixel: pixel};
      }
      const cols = this.mapFunc.mapObj.getFeaturesCollection(options);
      this.selectModeMultiple(cols, false);
    } else {
      this.selectModeSingle(pixel, false);
    }
  }
  // 15251 : use for google to select cluster
  singleSelectModeCluster(features) {
    if (this.multipleSelection) {
      this.selectModeMultiple(features, true);
    } else {
      features.forEach((f, i) => {
        this.selectModeSingle(f, true);
      });
    }
  }

  addRadioButton(element, title, checked, callBack) {
    const name = this.keyName + 'Control';
    const titleFinal = name + title;
    const radio = this.sclMapViews.createRadio(document, titleFinal, checked, name);

    if (this.disabled) {
        radio.disabled = this.disabled;
        radio.setAttribute('style', this.disabled ? 'cursor:not-allowed;' : '');
    }
    radio.onclick = callBack;

    const spanSwitcher = document.createElement('SPAN');
    spanSwitcher.setAttribute('role', 'tooltip');
    radio.appendChild(spanSwitcher);
    element.appendChild(radio);
    const label = document.createElement('label');
    label.setAttribute('for', titleFinal);
    const iSpan = document.createElement('span');
    iSpan.innerHTML = title;
    const css = { 'vertical-align': '-webkit-baseline-middle'};
    Object.assign(iSpan.style, css);

    label.appendChild(iSpan);

    element.appendChild(label);

    this.layerIds.push(radio);
    this.layerIds.push(label);
  }

  checkMapReady() {
    if (this.mapFunc.mapObj.isMapReady) {
      clearInterval(this.isMapReady);
      this.isMapReady = null; // reset

      this.mapFunc.resetupTooltipUI();
      let allowSearch = (this.mapFunc?.disableProcessingOnLoad ? false: true );
      this.searchAssetWhenMapReady(allowSearch);
      this.setupLoaddingMessagePosition();
    }
  }

  searchAssetWhenMapReady(allowSearch) {
    if (!allowSearch || this.initialMapView === INITIALMAPVIEW_KEYWORDS.NONE) {
      return;
    }

    if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.FILTER) {
      if ( !this.componentDefinition.filter) {
        console.log(`sc-address-map : With initialMapView set to filter you need to define a Filter.`);
      } else {
        this.totalSearchCount = 1;
        this.countGeoJson = 0;
        this.searchByFilter('map ready & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.FILTER, true);
      }
    } else if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.LAYERS) {
        if (!this.componentDefinition.layers || this.componentDefinition.layers.length === 0) {
          console.log(`sc-address-map : With initialMapView set to layers you need to define a some layers.`);
        } else {
          this.allowSearch = false;
          this.totalSearchCount = this.componentDefinition.layers.length;
          this.countGeoJson = 0;
          this.searchByLayers('map ready & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.LAYERS, true);
        }
    } else if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.ALL) {
      this.totalSearchCount = 0;
      this.countGeoJson = 0;
      this.searchAll('map ready & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.ALL);
    } else {
      this.isExistSelected('map ready & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.MAP);
    }
  }

  onMoveEnd(evt) {
    if (this.mapFunc.mapObj.isMapReady == false) { return; }
    if ((this.countLoadAssetProcess == 0 && this.mapFunc?.disableProcessingOnLoad)
      || (this.countLoadAssetProcess == 0 && this.initialMapView === INITIALMAPVIEW_KEYWORDS.NONE)
    ) {
      this.countLoadAssetProcess++;
      return;
    }
    const boudingBox = this.mapFunc.mapObj.getBoundingBox({EPSG: this.mapFunc.EPSG});
    if (boudingBox != null) {
        // DION - removed these adjusting of the bounding box
        // as we are now using relation : "intersects" in elastic query
        // left = left - 0.002;
        // top = top + 0.002;
        // bottom = bottom - 0.002;
        // right = right + 0.002;
        if (isNaN(boudingBox.minLon) || isNaN(boudingBox.maxLat) || isNaN(boudingBox.maxLon) || isNaN(boudingBox.minLat)) { return; }

        const coor = [boudingBox.minLon, boudingBox.maxLat];
        const coorNext = [boudingBox.maxLon, boudingBox.minLat];
        this.sclMapRulesInterfaceService.setCurrentMapviewCoords(this.componentDefinition.componentName,
          this.fieldName, [coor, coorNext], false, true, this.componentDefinition, this.document.documentId, this.mapFunc);

        // DION window[mapName] = [coor, coorNext];
        if (boudingBox.zoom <= 2) { return; }


        if (this.mapFunc.disableProcessingOnLoad && this.countLoadAssetProcess == 1
          && this.mapFunc.hasUpdateWatchField) {
          this.countLoadAssetProcess++;
          this.searchAssetWhenMapReady(true);
        } else {
          let hasSearch = false;
          if (this.allowSearch ) {
            hasSearch = this.searchByPosition('map move end', coor, coorNext, null);
          }
          this.allowSearch = true;
          if (!hasSearch) {
            // update label text for openlayers with zoom condition
            this.mapFunc.updateLabelByZoom();
            // this.mapFunc.updateRotateScaleByZoom();
          }
        }

    }
  }
  mapWatchStop() {
    const mapSize = this.mapFunc.mapObj.getMapSize();

    if (mapSize) {
      const mapWidth = mapSize[0];
      const mapHeight = mapSize[1];
      this.mapCenter = {x: mapWidth / 2, y: mapHeight / 2};
    } else {
      console.log(`Couldn't get size of map to enable tooltips`);
    }

    this.infoPosition = {left: '0px', top: '0px'};
    this.tooltipText = '';
    this.tooltipPosition = {left: '0px', top: '0px'}; // the position of the tooltip relative to infoPosition
    this.tooltipInfo.nativeElement.innerHTML = '';
    this.focusPopup = false;
    this.isPopoverOpen = false;

    this.infoRadioPosition = {left: '0px', top: '0px'};
  }
  resetSearchDelay() {
    this.lstQuery = [];
    if (this.mapFunc.requestId) {
      clearTimeout(this.mapFunc.requestId);
    }
    this.mapFunc.requestId = null;
    this.mapFunc.isRequesting = true;
  }
  searchAll(fromSource) {
    this.resetSearchDelay();
    const queries = [];
    if (!this.componentDefinition.filter) {
        console.log(`sc-address-map : With initialMapView set to all you need to define a Filter.`);
    } else {
      const filterIndex = this.defineFilterIndex();
      this.totalSearchCount++;
      // searchByFilter(true);
      const fil = this.sclUtilMapService.buildFilterObj(this.componentDefinition, this.addressField);
      queries.push({type: 'filter', layer: fil, i: filterIndex});
    }
    if (!this.componentDefinition.layers || this.componentDefinition.layers.length === 0) {
      console.log(`sc-address-map : With initialMapView set to all you need to define a some layers.`);
    } else {
      this.totalSearchCount += this.componentDefinition.layers.length;
      let idx = 0;
      for (let i = this.componentDefinition.layers.length - 1; i > -1; i--) {
        idx++;
        queries.push({type: 'layer', layer: this.componentDefinition.layers[i], i: idx});
      }
    }
    // searchAllDelay(0, queries);
    if (queries && queries.length > 0) {

      if (!this.currentBounds && this.hasBoundingBox) {
        const boudingBox = this.mapFunc.mapObj.getBoundingBox({EPSG: this.mapFunc.EPSG});
        if (boudingBox != null) {
          if (isNaN(boudingBox.minLon) || isNaN(boudingBox.maxLat)
          || isNaN(boudingBox.maxLon) || isNaN(boudingBox.minLat)) { return; }

          const coor = [boudingBox.minLon, boudingBox.maxLat];
          const coorNext = [boudingBox.maxLon, boudingBox.minLat];
          this.sclMapRulesInterfaceService.setCurrentMapviewCoords(this.componentDefinition.componentName,
            this.fieldName, [coor, coorNext], false, true, this.componentDefinition, this.document.documentId, this.mapFunc);
          this.currentBounds = this.sclMapRulesInterfaceService.getCurrentMapviewCoords(
            this.componentDefinition.componentName, this.fieldName
          );
        }
      }
      this.countQueries = queries.length;
      this.countFinishSearch = 0;
      queries.forEach((query) => {
        let newFilter = query.layer.filter;
        if (this.currentBounds && this.hasBoundingBox) {
          const hasBoundingBox = this.sclUtilMapService.hasBoundingBox(query.layer);
          newFilter = this.sclUtilMapService.getQueryGeo(this.currentBounds[0],
            this.currentBounds[1], newFilter, query.layer.geoJsonField,
            hasBoundingBox);
        }
        if (query.type === 'filter') {
          this.searchAssetFilter(fromSource + ' - filter', false, query.i, newFilter, () => {
            this.countFinishSearch++;
            this.checkFinishSearch();
          });
        } else {
          this.searchAssetLayer(fromSource + ' - layer', query.layer, query.i, false, false, newFilter, () => {
            this.countFinishSearch++;
            this.checkFinishSearch();
          });
        }
      });
    }
  }
  checkFinishSearch() {
    if (this.countFinishSearch === this.countQueries) {
      this.isSearchLayer = false;
      this.mapFunc.isRequesting = false;
      this.isLoadingAsset = false;
      this.mapFunc.mapObj.fit(this.configService, null, this.initialZoomChange);
      this.cdRef.detectChanges();
    }
  }
  searchByPosition(fromSource, coor, coorNext, isFit) {
    if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.ALL) { return false; }
    let hasSearch = false;
    if (!this.isSearchLayer) { this.resetSearchDelay(); }
    if (this.componentDefinition.filter && this.initialMapView !== INITIALMAPVIEW_KEYWORDS.FILTER) {
      if (this.isSearchLayer) {
        const fil = this.sclUtilMapService.buildFilterObj(this.componentDefinition, this.addressField);

        this.objSearchByPosition = {type: 'filter', coor: coor, coorNext: coorNext, layers: [ fil ] };
      } else {
        hasSearch = true;
        const filterIndex = this.defineFilterIndex();
        this.searchMultiAssetMove(fromSource + ' - filter & initialMapView != ' + INITIALMAPVIEW_KEYWORDS.FILTER, coor, coorNext
          , this.componentDefinition.filter, this.addressField, this.componentDefinition
          , this.componentDefinition.layerDisplayOnly, this.componentDefinition.filter + '_filter_' + filterIndex
          , () => {
            this.mapFunc.updateLabelAllLayers();
            if (!this.componentDefinition.layers || this.initialMapView === INITIALMAPVIEW_KEYWORDS.LAYERS) {
              this.isLoadingAsset = false;
              this.cdRef.detectChanges();
            }
        });
      }
    }
    if (this.componentDefinition.layers && this.componentDefinition.layers.length > 0 && this.initialMapView !== INITIALMAPVIEW_KEYWORDS.LAYERS) {

      if (this.isSearchLayer) {
        this.objSearchByPosition = {type: 'layer', coor: coor, coorNext: coorNext, layers: this.componentDefinition.layers };
      } else {
        if (this.componentDefinition.layers && this.componentDefinition.layers.length > 0) {
          hasSearch = true;
          this.searchByPositionCountQuery = this.componentDefinition.layers.length;
          this.searchByPositionCountFinishSearch = 0;

          let idx = 0;
          for (let i = this.componentDefinition.layers.length - 1; i > -1; i--) {
            idx++;
            const layer = this.componentDefinition.layers[i];
            let layerDisplayOnly = layer.layerDisplayOnly;
            if (typeof(layer.layerDisplayOnly) === 'undefined') { layerDisplayOnly = true; }

            let type = '_layer';
            if (this.objSearchByPosition && this.objSearchByPosition.type) { type = '_' + this.objSearchByPosition.type; }

            this.searchMultiAssetMove(fromSource + ' - layers & initialMapView != ' + INITIALMAPVIEW_KEYWORDS.LAYERS, coor, coorNext, layer.filter
              , layer.geoJsonField, layer, layerDisplayOnly
              , layer.filter + type + '_' + idx, () => {
              this.searchByPositionCountFinishSearch++;
              this.searchByPostionCheckFinish();
            });
          }
        } else {
          console.log(`calling searchByPostion but there has no layers in user config`);
        }
      }
    }
    return hasSearch;
  }
  searchByPostionCheckFinish() {
    if (this.searchByPositionCountFinishSearch === this.searchByPositionCountQuery) {
      this.objSearchByPosition = null; // reset after finish this search
      this.isLoadingAsset = false;
      this.cdRef.detectChanges();
      this.mapFunc.updateLabelAllLayers();
    }
  }
  searchMultiAssetMoveDelay(index, layerIndex, layers, searchFunction, coor, coorNext) {
    if (index < layers.length) {
      const layer = layers[index];
      let layerDisplayOnly = layer.layerDisplayOnly;
      if (typeof(layer.layerDisplayOnly) === 'undefined') { layerDisplayOnly = true; }

      if (layer.filter) {
        let type = '_layer';
        if (this.objSearchByPosition && this.objSearchByPosition.type) { type = '_' + this.objSearchByPosition.type; }
        searchFunction(coor, coorNext, layer.filter, layer.geoJsonField, layer, layerDisplayOnly
          , layer.filter + type + '_' + layerIndex, () => {
          if (!this.mapFunc.isRequesting) {
            this.isLoadingAsset = false;
            this.cdRef.detectChanges();
            return;
          }
          index++;
          layerIndex--;
          this.searchMultiAssetMoveDelay(index, layerIndex, layers, searchFunction, coor, coorNext);
        });
      } else {
        index++;
        layerIndex--;
        this.searchMultiAssetMoveDelay(index, layerIndex, layers, searchFunction, coor, coorNext);
      }
    } else {
      this.objSearchByPosition = null; // reset after finish this search
      this.mapFunc.updateLabelAllLayers();
    }
  }
  searchMultiAssetMove(fromSource, coor, coorNext, filterLayer, geoJsonField, layer, layerDisplayOnly, query, cb) {
    let filter = '';
    if (filterLayer) {
      const newFilter = sclHandlebars.processHandlebars(filterLayer, null, null, null, this.mapFunc.contextParams);
      const hasBoundingBox = this.sclUtilMapService.hasBoundingBox(layer);
      if (this.currentBounds) {
        filter = this.sclUtilMapService.getQueryGeo(this.currentBounds[0], this.currentBounds[1], newFilter, geoJsonField
          , hasBoundingBox);
      } else {
        filter = this.sclUtilMapService.getQueryGeo(coor, coorNext, newFilter, geoJsonField
          , hasBoundingBox);
      }

    }
    const options = {
      page: 0,
      pageSize: this.mapFunc.pageSize,
      document: this.document,
      filter : filter
    };
    this.lstQuery.push(options.filter);
    this.search(fromSource, options, geoJsonField, layer, false, layerDisplayOnly, query, null, null, cb);
  }
  searchByFilter(fromSource, isFit) {
    if (this.componentDefinition.filter) {
        this.resetSearchDelay();
        this.isSearchLayer = true;
        const filterIndex = this.defineFilterIndex();
        this.searchAssetFilter(fromSource + ' - fliter', isFit, filterIndex, this.componentDefinition.filter,
           () => {
            this.isSearchLayer = false; // if we got all result from searchFilter
            this.mapFunc.isRequesting = true;

            // 'calling search when moving map' must be happened after done searchFilter if we have searchFilter before
            if (this.objSearchByPosition) {
                if (this.objSearchByPosition.layers && this.objSearchByPosition.layers.length > 0) {
                  // this.objSearchByPosition.layers.forEach((layer1) => {
                    this.searchByPositionCountQuery = this.objSearchByPosition.layers.length;
                    this.searchByPositionCountFinishSearch = 0;
                    let idx = 0;
                    for (let i = this.objSearchByPosition.layers.length - 1; i > -1; i--) {
                      const layer = this.objSearchByPosition.layers[i];
                      idx++;
                      let layerDisplayOnly = layer.layerDisplayOnly;
                      if (typeof(layer.layerDisplayOnly) === 'undefined') { layerDisplayOnly = true; }
                      let type = '_layer';
                      if (this.objSearchByPosition && this.objSearchByPosition.type) {
                        type = '_' + this.objSearchByPosition.type;
                      }

                      this.searchMultiAssetMove(fromSource + ' - map has move event', this.objSearchByPosition.coor
                        , this.objSearchByPosition.coorNext
                        , layer.filter, layer.geoJsonField, layer, layerDisplayOnly
                        , layer.filter + type + '_' + idx
                        , () => {
                          this.searchByPositionCountFinishSearch++;
                          this.searchByPostionCheckFinish();
                      });
                    }
                  // });
                }
            } else {
              this.mapFunc.isRequesting = false;
              this.isLoadingAsset = false;
              this.cdRef.detectChanges();
            }
        });
    }
  }
  searchAssetFilter(fromSource, isFit, filterIndex, pFilter, cb) {
    const newFilter = sclHandlebars.processHandlebars(pFilter, null, null, null, this.mapFunc.contextParams);
    const filter = this.sclUtilMapService.parseQuery(newFilter, this.addressField);
    let filterJsonString = JSON.stringify(filter);

    const options = {
        page: 0,
        pageSize: this.mapFunc.pageSize,
        filter: filterJsonString, // filter,
        document: this.document
    };
    this.lstQuery.push(options.filter);
    this.search(fromSource, options, this.addressField, this.componentDefinition, isFit, this.componentDefinition.layerDisplayOnly
      , this.componentDefinition.filter + '_filter_' + filterIndex, 1, null, cb);
  }
  searchByLayers(fromSource, isFit) {
    this.countFit = 0;
    this.resetSearchDelay();

    if (this.componentDefinition.layers && this.componentDefinition.layers.length > 0) {
        this.isSearchLayer = true;
        // searchDelay(0, field.layers, searchAssetLayer, isFit, false);
        this.searchByLayerCountFinishSearch = 0;
        this.searchByLayerCountQuery = this.componentDefinition.layers.length;
        let idx = 0;
        for (let i = this.componentDefinition.layers.length - 1; i > -1; i--) {
          const layer = this.componentDefinition.layers[i];
          idx++;
          this.searchAssetLayer(fromSource, layer, idx, isFit, false, layer.filter, () => {
              if (!this.mapFunc.isRequesting) { return; }
              this.searchByLayerCountFinishSearch++;
              if (this.searchByLayerCountFinishSearch === this.searchByLayerCountQuery) {
                this.isSearchLayer = false; // if we got all result from searchLayer
                this.mapFunc.isRequesting = false;
                this.isLoadingAsset = false;
                this.cdRef.detectChanges();

                this.currentBounds = this.sclMapRulesInterfaceService.getCurrentMapviewCoords(
                  this.componentDefinition.componentName, this.fieldName);


                // 'calling search when moving map' must be happened after done searchLayer if we have searchLayer before
                if (this.objSearchByPosition) {
                    if (this.objSearchByPosition.layers && this.objSearchByPosition.layers.length > 0) {
                      this.searchByPositionCountQuery = this.objSearchByPosition.layers.length;
                      this.searchByPositionCountFinishSearch = 0;
                      let idx = 0;
                      for (let i = this.objSearchByPosition.layers.length - 1; i > -1; i--) {
                        const layer1 = this.objSearchByPosition.layers[i];
                        idx++;
                        let layerDisplayOnly = layer1.layerDisplayOnly;
                        if (typeof(layer1.layerDisplayOnly) === 'undefined') { layerDisplayOnly = true; }
                        let type = '_layer';
                        if (this.objSearchByPosition && this.objSearchByPosition.type) { type = '_' + this.objSearchByPosition.type; }

                        this.searchMultiAssetMove(fromSource + ' - has map move event', this.objSearchByPosition.coor
                          , this.objSearchByPosition.coorNext
                          , layer1.filter, layer1.geoJsonField, layer1, layerDisplayOnly
                          , layer1.filter + type + '_' + idx
                          , () => {
                          this.searchByPositionCountFinishSearch++;
                          this.searchByPostionCheckFinish();
                        });
                      };
                    }
                }
              }
          });
        }
    }
  }
  searchDelay(index, layerIndex, layers, searchFunction, isFit, isRefreshFeature) {
    if (index < layers.length) {
      const layer = layers[index];
      searchFunction(layer, layerIndex, isFit, isRefreshFeature, layer.filter, () => {
          if (!this.mapFunc.isRequesting) { return; }
          index++;
          layerIndex--;
          this.searchDelay(index, layerIndex, layers, searchFunction, isFit, isRefreshFeature);
      });
    } else {
      this.isSearchLayer = false; // if we got all result from searchLayer
      this.mapFunc.isRequesting = false;
      this.isLoadingAsset = false;
      this.cdRef.detectChanges();
      // 'calling search when moving map' must be happened after done searchLayer if we have searchLayer before
      if (this.objSearchByPosition) {
        this.searchMultiAssetMoveDelay(0, this.objSearchByPosition.layers.length
          , this.objSearchByPosition.layers, this.searchMultiAssetMove.bind(this)
          , this.objSearchByPosition.coor, this.objSearchByPosition.coorNext);
      }
    }
  }
  searchAssetLayer(fromSource, layer, layerIndex, isFit, isRefreshFeature, filter, cb) {
    const newFilter = sclHandlebars.processHandlebars(filter, null, null, null, this.mapFunc.contextParams);
    this.lstQuery.push(newFilter);

    let layerDisplayOnly = layer.layerDisplayOnly;
    if (typeof(layer.layerDisplayOnly) === 'undefined') { layerDisplayOnly = true; }

    const options = {
      page: 0,
      pageSize: this.mapFunc.pageSize,
      document: this.document,
      filter : newFilter // layer.filter
    };

    this.search(fromSource, options, layer.geoJsonField, layer, isFit, layerDisplayOnly
      , layer.filter + '_layer_' + layerIndex, this.componentDefinition.layers.length, isRefreshFeature, cb);

  }
  // 14934: searchAssetLayerUpdate = searchAssetLayer and use for updateWatchFields update layer
  searchAssetLayerUpdate(fromSource, data) {
    const layer = data.layer;
    const layerKey = data.layerKey;
    const layerIndex = data.layerIndex;
    const isFit = false;
    const isRefreshFeature = false;
    const cb = null;
    let layerDisplayOnly = layer.layerDisplayOnly;
    this.assetTotal = 0;
    this.assetLoaded = 0;
    if (typeof(layer.layerDisplayOnly) === 'undefined') { layerDisplayOnly = true; }

    let newFilter = sclHandlebars.processHandlebars(layer.filter, null, null, null, this.mapFunc.contextParams);
    const hasBoundingBox = this.sclUtilMapService.hasBoundingBox(layer);
    if (this.currentBounds) {
      newFilter = this.sclUtilMapService.getQueryGeo(this.currentBounds[0],
        this.currentBounds[1], newFilter, layer.geoJsonField
        , hasBoundingBox);
    } else {
      // begin 15268#c58639
      let coor = null;
      let coorNext = null;
      if (this.hasBoundingBox) {
        const boudingBox = this.mapFunc.mapObj.getBoundingBox({EPSG: this.mapFunc.EPSG});
        if (boudingBox != null) {
          if (isNaN(boudingBox.minLon) || isNaN(boudingBox.maxLat)
          || isNaN(boudingBox.maxLon) || isNaN(boudingBox.minLat)) { return; }

          coor = [boudingBox.minLon, boudingBox.maxLat];
          coorNext = [boudingBox.maxLon, boudingBox.minLat];
          this.sclMapRulesInterfaceService.setCurrentMapviewCoords(this.componentDefinition.componentName,
            this.fieldName, [coor, coorNext], false, true, this.componentDefinition, this.document.documentId, this.mapFunc);
          if (boudingBox.zoom <= 2) { return; }
        }
      }
      newFilter = this.sclUtilMapService.getQueryGeo(coor, coorNext, newFilter, layer.geoJsonField
            , hasBoundingBox);
    }


    // end 15268#c58639
    const options = {
        page: 0,
        pageSize: this.mapFunc.pageSize,
        document: this.document,
        filter : newFilter, // layer.filter
        layerKey: layerKey
    };
    let layerFilter = options.filter;
    if (typeof layerFilter !== 'string') {
        layerFilter = JSON.stringify(options.filter);
    }
    this.mapFunc.updateWatchFieldsLayerKey[layerKey] = layerFilter; // 14934
    this.search(fromSource, options, layer.geoJsonField, layer, isFit, layerDisplayOnly, layer.filter + '_layer_' + layerIndex
    , this.componentDefinition.layers.length, isRefreshFeature, cb);
  }
  searchOther(fromSource) {
    if (this.searchType !== this.initialMapView) { return; }
    if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.FILTER) {
      this.searchType = 'layers';
      this.allowSearch = false;
      this.searchByLayers(fromSource + ' - initialMapView = filter', true);
    } else if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.LAYERS) {
      this.searchType = 'filter';
      this.searchByFilter(fromSource + ' - initialMapView = layers', true);
    }
  }
  fitFeatures() {
    const length = this.mapFunc.mapObj.getAllFeatures().length;
    if (length === 0) {
      this.searchOther('fit feature when there has no feature in map');
      this.allowSearch = false;
    } else {
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        this.fitFeaturesOL(); //
      } else {
        this.fitFeaturesGG();
      }
      if (this.searchType === this.initialMapView) {this.allowSearch = true; }
    }
  }
  fitFeaturesGG() {
    if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.FILTER) {
      this.mapFunc.mapObj.fitLayerIndex(this.filterLayerIndex);
    } else {
      this.mapFunc.mapObj.fit(this.configService, null, this.initialZoomChange);
    }
  }
  fitFeaturesOL() {
    if (this.xMin && this.yMin && this.xMax && this.yMax) {
      if (this.intervalWaitForLoadAssetImage) {
        clearInterval(this.intervalWaitForLoadAssetImage);
        this.intervalWaitForLoadAssetImage = null; // reset
        this.countWaitForLoadAssetImage = 0; // reset
      }
      this.fitCurrentBound();

      if (this.assetFitCount > 0) {
        this.intervalWaitForLoadAssetImage = setInterval(this.waitForLoadAssetImageWithCounter.bind(this), 200);
      } else {
        this.intervalWaitForLoadAssetImage = setInterval(this.waitForLoadAllAssetImage.bind(this), 200);
      }
    }
  }
  waitForLoadAllAssetImage() {
    if (this.mapFunc.countAssetPoint < this.mapFunc.mapObj.countGetImgSrc) {
      this.waitForLoadAssetImage();
    } else {
      this.doneWaitForLoadAssetImage();
    }
    this.cdRef.detectChanges();
  }
  waitForLoadAssetImageWithCounter() {
	/*
    console.log(`**** this.assetFitCount = ${this.assetFitCount}
       , this.countAssetPoint = ${this.mapFunc.countAssetPoint}
       , this.mapObj.countGetImgSrc ${this.mapFunc.mapObj.countGetImgSrc}`);
	*/

    if (this.mapFunc.countAssetPoint > this.assetFitCount) {
      if (this.mapFunc.mapObj.countGetImgSrc < this.assetFitCount) {
        this.waitForLoadAssetImage();
      } else {
        this.doneWaitForLoadAssetImage();
      }
    } else {
      if (this.mapFunc.mapObj.countGetImgSrc < this.mapFunc.countAssetPoint) {
        this.waitForLoadAllAssetImage();
      } else {
        this.doneWaitForLoadAssetImage();
      }
    }

    this.cdRef.detectChanges();
  }
  waitForLoadAssetImage() {
    this.isLoadingIconAsset = true;
    this.countWaitForLoadAssetImage++;
    if (this.countWaitForLoadAssetImage > this.limitWaitForLoadAssetImage) {
      this.isLoadingIconAsset = false;
      console.log(`Finish waiting for load all asset image, can\'t load all image !`);
      clearInterval(this.intervalWaitForLoadAssetImage);
      this.intervalWaitForLoadAssetImage = null;
      this.countWaitForLoadAssetImage = 0;
      this.fitCurrentBound();
    }
  }
  doneWaitForLoadAssetImage(){
    this.isLoadingIconAsset = false;
    clearInterval(this.intervalWaitForLoadAssetImage);
    this.intervalWaitForLoadAssetImage = null;

    this.fitCurrentBound();
  }
  fitCurrentBound() {
    if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.FILTER)  {
      let box;
      if (this.mapFunc.systemMapLimit) {
        box = this.mapFunc.mapObj.getLayerSourceBoundingBox(this.filterLayerIndex
          , this.mapFunc.systemMapLimit , this.mapFunc.EPSG);
      } else {
        box = this.mapFunc.mapObj.layerAssets[this.filterLayerIndex].getSource().getExtent();
      }
      if (box != null && box.length === 4 && isFinite(box[0]) && isFinite(box[1])
       && isFinite(box[2]) && isFinite(box[3]) ) {

        this.mapFunc.mapObj.view.fit(box, this.mapFunc.mapObj.map.getSize());
      }
    } else {
      // console.log(`**** fitCurrentBound for LAYERS`);
      const box = [this.xMin, this.yMin, this.xMax, this.yMax];
      let boundingExtent = box;
      if (this.mapFunc.systemMapLimit) {
        boundingExtent = this.mapFunc.mapObj.validateBox(box, this.mapFunc.systemMapLimit, this.mapFunc.EPSG);
      }
      // console.log('**** box = ', box);
      // console.log('**** boundingExtent = ', boundingExtent);
      this.mapFunc.mapObj.map.getView().fit(boundingExtent,
        {
          size: this.mapFunc.mapObj.map.getSize(),
          padding: [this.mapFunc.mapObj.fitPadding, this.mapFunc.mapObj.fitPadding
            , this.mapFunc.mapObj.fitPadding, this.mapFunc.mapObj.fitPadding]
        } );
      this.mapFunc.updateLabelByZoom();
      //console.log(`OL FIT, xMin = ${this.xMin}, yMin = ${this.yMin}, xMax = ${this.xMax}
      //, yMax = ${this.yMax}`);
    }
  }

  accumulateExtent(ext) {
    if (ext && ext.length === 4 && isFinite(ext[0]) && isFinite(ext[1]) && isFinite(ext[2]) && isFinite(ext[3])) {
      if (this.xMin === undefined || this.xMin === null || ext[0] < this.xMin) {
        this.xMin = ext[0];
      }
      if (this.yMin === undefined || this.yMin === null || ext[1] < this.yMin) {
        this.yMin = ext[1];
      }
      if (this.xMax === undefined || this.xMax === null || ext[2] > this.xMax) {
        this.xMax = ext[2];
      }
      if (this.yMax === undefined || this.yMax === null || ext[3] > this.yMax) {
        this.yMax = ext[3];
      }
    }
  }
  checkCurrentSelected() {
    if (this.fieldValue === null) {
      return;
    }
    if (this.currentSelected.length > 0) {
      // sort selected item follow this.fieldValue;
      const newSelected = [];
      for (let i = 0; i < this.fieldValue.length; i++) {
        const id = this.fieldValue[i].documentId;
        this.currentSelected.forEach((fea) => {
          const fId = this.mapFunc.mapObj.getFeatureId(fea);
          if (fId.indexOf(id) > -1) {
            newSelected.push(fea);
            return;
          }
        });
      }
      this.currentSelected = newSelected;
      //
      this.currentSelected.forEach((entry1) => {
            const fId = this.mapFunc.mapObj.getFeatureId(entry1);
            const fea = this.mapFunc.mapObj.getFeatureByLayer(fId, this.mapFunc.mapObj.layerIndexUser);
            if (fea === null) {
                const fClone = this.mapFunc.mapObj.featureClone(entry1, this.mapFunc.mapObj.layerIndexUser);
                this.mapFunc.mapObj.addFeature(fClone, this.mapFunc.mapObj.layerIndexUser);
            }
        });
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        if (this.multipleSelection) {
          this.mapFunc.mapObj.layerAssets[this.mapFunc.mapObj.layerIndexUser].setVisible(true);
        } else { this.mapFunc.mapObj.layerAssets[this.mapFunc.mapObj.layerIndexUser].setVisible(false); }
      } else {
        if (this.multipleSelection) {
          this.mapFunc.mapObj.addInteractionSelect(this.currentSelected); // TO DO : 13835
        } else { this.mapFunc.mapObj.removeInteractionSelect(); }
      }
    }
  }
  getToolTips(tooltips, handlebarsContext) {
    tooltips = sclHandlebars.processHandlebars(tooltips, handlebarsContext, null, null, this.mapFunc.contextParams);

    if (this.isDisplayImage && handlebarsContext.queryResultDocument.systemHeader.imageFileNo96) {
      // no define serverRoutes ***
      // const icon = serverRoutes.loadFile + '/' + handlebarsContext.queryResultDocument.systemHeader.imageFileNo96;
      // tooltips += '<img src=\'' + icon + '\' />';
    }
    return tooltips;
  }
  // just for change filter
  watchEventList(data) {
    if (data && data.OnChangeFilter) {
      const value = data.OnChangeFilter;
      if (value && value.affectedFieldName === this.fieldName &&
          value.affectedDocId === this.document.documentId) {
          console.log(`%c Address map filter has changed event...............`, 'color:purple');
          this.mapFunc.mapObj.clearAllFeatures(); // vectorSource.clear();

          // update filter
          const filterIndex = this.defineFilterIndex();
          this.mapFunc.layerAssets[this.mapFunc.layerAssets.length - 1].query = value.newFilter + '_filter_' + filterIndex;

          // DION - added in to reset initialMapView, as filter has been changed
          if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.FILTER) {
            this.searchByFilter('filter has change & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.FILTER, true);
            this.searchByLayers('filter has change & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.FILTER, false);
          } else if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.LAYERS) {
            // DION - not sure what this is trying to achieve apart from not loading on next zoom ??
            // allowSearch = false;
            this.searchByLayers('filter has change & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.LAYERS, true);
            this.searchByFilter('filter has change & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.LAYERS, false);
          } else if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.ALL) {
            this.searchByFilter('filter has change & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.ALL, true);
            this.searchByLayers('filter has change & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.ALL, true);
          } else if (this.initialMapView === INITIALMAPVIEW_KEYWORDS.MAP) {
            // position map at location in config file
            // isExistSelected();
            // scope.sclUtilMap.positionView(view, defaultLon, defaultLat, defaultZoom, EPSG);
            this.mapFunc.mapObj.positionView( this.defaultLat, this.defaultLon
              , this.defaultZoom, this.mapFunc.EPSG);
            this.searchByFilter('filter has change & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.MAP, false);
            this.searchByLayers('filter has change & initialMapView = ' + INITIALMAPVIEW_KEYWORDS.MAP, false);
          }
      }
    }
  }
  isExistSelected(fromSource) {
    const key = this.fieldName;
    if (this.document[key] && this.document[key].length > 0) {
      const savedSelected = this.document[key];
      let j;
      for (j = 0; j < savedSelected.length; j++) {
        const item = savedSelected[j];
        const docId = item.documentId;
        const fea = this.mapFunc.mapObj.getFeatureById(docId); // vectorSource.getFeatureById(docId);
        if (!fea) {
          const sql = '{\'query\':{\'bool\':{\'filter\':[{\'term\':{\'documentId\':\'' + docId + '\'}}]}}}';
          const filter = this.sclUtilMapService.parseQuery(sql, this.addressField);
          const options = {
              page: 0,
              pageSize: this.mapFunc.pageSize,
              filter: filter,
              document: this.document
          };
          if (this.lstQuery.indexOf(options.filter) < 0) { this.lstQuery.push(options.filter); }
          this.search(fromSource, options, this.addressField, this.componentDefinition, true
            , this.componentDefinition.layerDisplayOnly, sql, null, null, null); // query = sql ??????
        }
      }
    }
  }
  addCurrentSelected(feature, id) {
    const key = this.fieldName;
    if (this.document[key] && this.document[key].length > 0) {
      const savedSelected = this.document[key];
      let j;
      for ( j = 0; j < savedSelected.length; j++) {
        const item = savedSelected[j];
        if (item && item.documentId && item.documentId === id) {
          const fClone = this.mapFunc.mapObj.featureClone(feature, this.mapFunc.mapObj.layerIndexUser);
          this.currentSelected.push(fClone);
          break;
        }
      }
    }
  }
  getHandlerValue(data) {
    const qualityRegex = /{{{?(.*?)?[a-z]+.[a-z]*}?}}/g;
    let matches: any[];
    const qualities = [];

    // tslint:disable-next-line: no-conditional-assignment
    while (matches = qualityRegex.exec(data)) {
      const match0 = matches[0];
      const item = match0.replace('{{{', '').replace('}}}', '');
      qualities.push(item);
    }

    return qualities;
  }
  search(fromSource, options, geoJsonField, layer, isFit, layerDisplayOnly, query, count, isRefreshFeature, cb) {
    if (layer.type === 'dynamic') { // 16049
      this.mapFunc.searchWebService(
        {
          layer,
          layerDisplayOnly,
          isRefreshFeature,
          count: this.componentDefinition.layers.length,
          isFit,
          compType: MapComponentName.ADDRESS_MAP,
        }, cb);
    } else {

      const dataSource = this.searchClientService.getDefaultSearchProvider(this.mapFunc.setupContext());
      if (layer.queryName) {
        // options.dataSource = dataSource;
        // options.queryName = layer.queryName;
        // options.searchOfflineOnly = this.componentDefinition?.searchOptions?.searchOfflineOnly;

        options = this.mapFunc.setupSearchOptions(options, layer, dataSource);
      }

      const color = layer.color;

      // const imageFileNo = layer.imageFileNo;
      const tooltip = layer.tooltips;
      const tooltipsTimeout = layer.tooltipsTimeout;
      const labelText = layer.labelText;


      if (!options.filter ||
         ( (typeof options.filter === 'string' || options.filter instanceof String)
          && options.filter.trim().length == 0 )  ) {
        this.countFit++;
        console.log(`Layer has no filter: `, layer);
        if (cb && typeof cb === 'function') { cb(); }
        return;
      }

      this.outstandingFilter = options.filter;
      options.sourceFilter = [geoJsonField ,  'documentId', 'systemHeader.summaryName', 'systemHeader.createdDate'];
      // parsing of tooltips and labelText are retained for backwards compatability.
      if (typeof layer.tooltips !== undefined && layer.tooltips !== null && layer.tooltips !== undefined) {
          const sf = this.getHandlerValue(layer.tooltips);
          if (sf.length > 0) {
              for (let i = 0; i < sf.length; i++) {
                if (options.sourceFilter.indexOf(sf[i]) < 0) { options.sourceFilter.push(sf[i]); }
              }
          }
      }
      if (typeof this.componentDefinition.tooltips !== undefined && this.componentDefinition.tooltips !== null
         && this.componentDefinition.tooltips !== undefined) {
          const sf = this.getHandlerValue(this.componentDefinition.tooltips);
          if (sf.length > 0) {
            for (let i = 0; i < sf.length; i++) {
              if (options.sourceFilter.indexOf(sf[i]) < 0) { options.sourceFilter.push(sf[i]); }
            }
          }
      }
      if (layer.labelText) {
          const sf = this.getHandlerValue(layer.labelText);
          if (sf.length > 0) {
            for (let i = 0; i < sf.length; i++) {
              if (options.sourceFilter.indexOf(sf[i]) < 0) { options.sourceFilter.push(sf[i]); }
            }
          }
      }
      if (layer.labelTextHandlebars) {
          const sf = this.getHandlerValue(layer.labelTextHandlebars);
          if (sf.length > 0) {
            for (let i = 0; i < sf.length; i++) {
              if (options.sourceFilter.indexOf(sf[i]) < 0) { options.sourceFilter.push(sf[i]); }
            }
          }
      }
      // Adding manual addition of fields to retrieve in queries to handle complex handlebar requirements
      // supported for overall component in root config
      if (typeof this.componentDefinition.additionalQueryFields !== undefined && this.componentDefinition.additionalQueryFields !== null &&
        this.componentDefinition.additionalQueryFields !== undefined) {
          const sf = this.componentDefinition.additionalQueryFields;
          if (sf.length > 0) {
              for (let i = 0; i < sf.length; i++) {
                if (options.sourceFilter.indexOf(sf[i]) < 0) { options.sourceFilter.push(sf[i]); }
              }
          }
      }
      // Supported for individual layer
      if (typeof layer.additionalQueryFields !== undefined && layer.additionalQueryFields !== null &&
              layer.additionalQueryFields !== undefined) {
          const sf = layer.additionalQueryFields;
          if (sf.length > 0) {
              for (let i = 0; i < sf.length; i++) {
                if (options.sourceFilter.indexOf(sf[i]) < 0) { options.sourceFilter.push(sf[i]); }
              }
          }
      }
      console.log(`Layer search SourceFilter is : ${options.sourceFilter}`);
      const layerClone = cloneDeep(layer);

      let heatmapPoints = (typeof layer.heatmapPoints === 'undefined' || layer.heatmapPoints === null) ? 'Center' : layer.heatmapPoints ;
      if (heatmapPoints !== 'Points') { heatmapPoints = 'Center'; }

      this.searchPagingAsync(fromSource, options,
        {
          geoJsonField,
          layer,
          query,
          layerClone,
          heatmapPoints,
          isFit,
          layerDisplayOnly,
          count,
          isRefreshFeature,
          tooltip,
          tooltipsTimeout,
          labelText,
        }, () => {
              if (cb && typeof cb === 'function') { cb(); }
          });
    }


  }
  searchPagingAsync(fromSource, options, params, cb) {
    this.isLoadingIconAsset = false;
    this.isLoadingAsset = false;
    this.cdRef.detectChanges();
    let layer = params.layer;
    const isFit = params.isFit;
    let query = params.query;
    const count = params.count;
    let canFetchMore = false;
    let layerIndex = -1;
    let queryName = '';
    for (let li = 0; li < this.mapFunc.layerAssets.length; li++) {
      if (this.mapFunc.layerAssets[li].query === query && this.mapFunc.layerAssets[li].layer.type === layer.type ) {
        layerIndex = this.mapFunc.layerAssets[li].i;
        queryName = this.mapFunc.layerAssets[li].layer.queryName;
        break;
      }
    }

    if (layerIndex < 0) {
      console.log(`layerIndex is invalid`);
      if (cb && typeof cb === 'function') { cb(); }
    } else {
      this.isLoadingAsset = true;
      this.cdRef.detectChanges();
      const startTimeRequest: any = new Date();
      if (this.mapFunc.showTiming) {
        console.log(` from: ${fromSource}, layer[${layerIndex}]
           start time request asset = ${startTimeRequest.toISOString()}
          \n\t, query = ${options.filter}
          \n\t, queryName = ${queryName}`);
      }
      this.searchClientService.search(options)
      .then(
      ((currentOption) => {
        if (this.mapFunc.showTiming) {
          const endTimeRequest: any = new Date();
          const totalTimeRequest: any = (endTimeRequest - startTimeRequest) / 1000;
          console.log(` from: ${fromSource}, layer[${layerIndex}]
            end time return asset = ${endTimeRequest.toISOString()}
            \n\t, start time = ${startTimeRequest.toISOString()}
            \n\t, total time = ${totalTimeRequest} (seconds)`);
        }
        return (dataResult) => {
          let needFit = false; // DION - only fit if data is there to fit!
          let data = this.mapFunc.getDataWithSearchProvider(dataResult);
          let customData = data.data;
          this.totalSearchCount--;
          if (customData && customData.length > 0) {
            //
            let resultCount = this.mapFunc.pageSize;
            if (this.mapFunc.pageSize > customData.length) {
              resultCount = customData.length;
            }
            if (data.total > this.maxQueryReturnResults) {
              console.log(`Query returned ${data.total} results
                              , maximum limit we can process is ${this.maxQueryReturnResults}
                               reduce the results to display on the map`);
            }
            const totalAsset = (data.total > this.maxQueryReturnResults ? this.maxQueryReturnResults : data.total);
            const prevAssetTotal = this.assetTotal;
            if (this.assetTotal + totalAsset > this.maxQueryReturnResults) {
              this.assetTotal = this.maxQueryReturnResults;
            } else {
              this.assetTotal += totalAsset;
            }

            const remain = this.assetTotal - resultCount - prevAssetTotal;

            this.assetLoaded += resultCount;
            this.cdRef.detectChanges();
            params.layerIndex = layerIndex;
            options.from = 0;
            params.options = options;
            params.pageIndex = 0;
            let that = this;
            this.parseData(dataResult, params, (pNeedFit) => {
              needFit = pNeedFit;
              if (remain > 0) {// if can fetch more data
                canFetchMore = true;
                const divide = Math.floor(remain / this.mapFunc.pageSize) ;
                let modulus = remain % this.mapFunc.pageSize;
                if (modulus > 0) {
                    modulus = 1;
                }
                const len = divide + modulus;
                let countAsyncDone = len;
                const from = this.mapFunc.pageSize;

                const asyncIterable = {
                  index: 0,
                  len: len,
                  [Symbol.asyncIterator]() {
                    return {
                      current: this.index,
                      last: this.len,
                      next(): Promise<any> {
                        if (this.current < this.last) {
                          const subOp = cloneDeep(options);
                          subOp.from = (from * this.current) + that.mapFunc.pageSize;
                          let pageIndex = (this.current + 1);
                          subOp.pageIndex = pageIndex;
                          if (that.mapFunc.showTiming) {
                            if (layerIndex) {
                              console.log(` from: ${fromSource}, layer[${layerIndex}]
                               start time ${(new Date()).toISOString()} for fetching data page: ${this.current}`);
                            } else {
                              console.log(` from: ${fromSource}
                                , start time ${(new Date()).toISOString()} for fetching data page: ${this.current}
                                \n\t, query = ${JSON.stringify(options.filter)}`);
                            }
                          }
                          that.searchClientService.search(subOp)
                          .then(
                            (dataResult1) => {
                              const startTimeDraw1: any = new Date();
                              if (that.mapFunc.showTiming) {
                                  console.log(` from: ${fromSource}, layer[${layerIndex}]
                                   end time ${startTimeDraw1.toISOString()}
                                    for fetching data page: ${subOp.pageIndex} & start time drawing asset`);
                              }
                              let data1 = that.mapFunc.getDataWithSearchProvider(dataResult1);
                              customData = data1.data;

                              that.assetLoaded += customData.length;
                              that.cdRef.detectChanges();
                              params.pageIndex = pageIndex;
                              params.options = subOp;
                              that.parseData(dataResult1, params, () => {
                                countAsyncDone--;
                                if (that.mapFunc.showTiming) {
                                  const endTimeDraw1 = new Date();
                                  console.log(` from: ${fromSource}, layer[${layerIndex}]
                                   end time drawing asset ${(new Date()).toISOString()}
                                    of page: ${subOp.pageIndex}`);
                                }
                                if (countAsyncDone === 0) {
                                  canFetchMore = false;
                                  that.finishSearchAsync(count, canFetchMore, needFit, layer, layerIndex, cb);
                                }
                              });
                          }, (err) => {
                              console.log(`error in AddressMap:`, err);
                              if (that.mapFunc.showTiming) {
                                console.log(`(error) from: ${fromSource}, layer[${layerIndex}]
                                 end time ${(new Date()).toISOString()}
                                 for fetching data page: ${subOp.pageIndex}`);
                              }
                              countAsyncDone--;
                              if (countAsyncDone === 0) {
                                canFetchMore = false;
                                that.finishSearchAsync(count, canFetchMore, needFit, layer, layerIndex, cb);
                              }
                          });
                          return Promise.resolve({ value: this.current++, done: false });

                        }
                        return Promise.resolve({ done: true });
                      }
                    };
                  }
                };

                async function main() {
                  for await(const num of asyncIterable){
                    // console.log('num = ' + num);
                  }
                }
                main()
                .then(r => {
                  // console.log(r);
                })
                .catch(err => console.log(err));
              } else {
                needFit = isFit;
                canFetchMore = false;
                this.finishSearchAsync(count, canFetchMore, needFit, layer, layerIndex, cb);
              }

            });

          } else {
            if (this.mapFunc.showTiming) {
              const endTimeDraw: any = new Date();
              const totalTimeDraw = (endTimeDraw - startTimeRequest) / 1000;
              console.log(` from: ${fromSource}, layer[${layerIndex}]
               end time drawing asset ${endTimeDraw.toISOString()}
               \n\t, start time: ${startTimeRequest.toISOString()}
               \n\t, total time: ${totalTimeDraw} (seconds)`);
            }
            needFit = isFit;
            canFetchMore = false;
            this.finishSearchAsync(count, canFetchMore, needFit, layer, layerIndex, cb);
          }
        };
      })(options), (err) => {
        if (this.mapFunc.showTiming) {
          const endTimeRequest: any = new Date();
          const totalTimeRequest: any = (endTimeRequest - startTimeRequest) / 1000;
          console.log(` from: ${fromSource}, layer[${layerIndex}]
            end time return asset = ${endTimeRequest.toISOString()}
            \n\t, start time = ${startTimeRequest.toISOString()}
            \n\t, total time = ${totalTimeRequest} (seconds)
            \n\t, ERROR CASE`);
        }
        console.log(`error in AddressMap:`, err);
        console.log(`|===> error in AddressMap, filter = ${options.filter}`);
        canFetchMore = false;
        this.finishSearchAsync(count, canFetchMore, isFit, layer, layerIndex, cb);
      }); // end searchService
    }
  }
  checkValidQuery(options) {
    // 14934
    if ( (typeof options.layerKey !== 'undefined' && !this.mapFunc.checkLayerKey(options.layerKey, options.filter)) ) {
	  /*
      console.log(`%c invalid layerKey, options.layerKey = ${options.layerKey}
        , current filter key = ${this.mapFunc.updateWatchFieldsLayerKey[options.layerKey]}
        , options.filter = ${options.filter}`, 'color:green');
		*/
      return false;
    }
    return true;
  }
  createNewFeature(fData) {
    const feature = this.createFeature(fData);
    // needFit = isFit;

    if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
      const ext = feature.getGeometry().getExtent();
      this.accumulateExtent(ext);
    }
  }
  updateExistedFeature(fea, label, fData, isRefreshFeature) {
    this.mapFunc.updateLabel(fea, label);

    if (isRefreshFeature) {
      this.mapFunc.mapObj.removeFeature(fea);
      const feature = this.createFeature(fData);
      // needFit = isFit;
    }
  }
  parseData(data, params, cb) {
    const dataWithProviders = this.mapFunc.getDataWithSearchProvider(data);
    const customData = dataWithProviders.data;
    const geoJsonField = params.geoJsonField;
    const layer = params.layer;
    const isFit = params.isFit;
    const layerDisplayOnly = params.layerDisplayOnly;
    // const query = params.query;
    // const count = params.count;
    const isRefreshFeature = params.isRefreshFeature;
    // const color = params.color;
    const tooltip = params.tooltip;
    // const tooltipsTimeout = params.tooltipsTimeout;
    const labelText = params.labelText;
    const heatmapPoints = params.heatmapPoints;
    const layerClone = params.layerClone;
    const layerIndex = params.layerIndex;
    let needFit = false;
    let i = 0;
    if (customData && customData.length > 0 && layerIndex > -1) {
      this.testCountAsset += customData.length;
      this.checkGeoJsonCount(customData.length);
      SearchResultsProcessor.processSearchResults(data, async (itemData) => {
        // elementProcessingCallback
        const isValid = this.checkValidQuery(params.options);
        if (isValid) {
            const obj = await this.mapFunc.drawAsset({
              i,
              itemData,
              geoJsonField,
              layerIndex,
              layer,
              heatmapPoints,
              isFit,
              customData,
              tooltip,
              layerClone,
              layerDisplayOnly,
              isRefreshFeature,
              compType: MapComponentName.ADDRESS_MAP,
            });

            needFit = obj.needFit;


        }
        i++;
        if (i == customData.length && cb && typeof cb === 'function') {
          cb(isFit);
        }
      }, () => {
          // completionCallback
          // if (cb && typeof cb === 'function') {
          //     cb(isFit);
          // }
      });
    } else {
	  /*
      console.log(`%c search query = ${params.query}, from = ${params.options.from}
       , pageIndex = ${params.pageIndex}
       , customData is NULL or count = 0, layerIndex = ${layerIndex}`, 'color:cyan');
	   */
      this.checkGeoJsonCount(0);
      if (cb && typeof cb === 'function') {
        cb(isFit);
      }
    }
  }
  finishSearchAsync(count, canFetchMore, needFit, layer, layerIndex, cb) {
    if (count && !canFetchMore) { this.countFit++; }
    if (needFit && !canFetchMore) { // if(isFit){
      if (count) {
        if (this.countFit >= count) {
          this.fitFeatures();
          this.isExistSelected('finish searching');
        }
      } else {
        this.fitFeatures();
        this.isExistSelected('finish searching');
      }
    }
    this.checkCurrentSelected();
    if (layer.type === 'heatmap') {
      this.mapFunc.mapObj.createHeatMap(layerIndex);
    }
    if ( !canFetchMore && cb && typeof cb === 'function') { cb(); }
  }

  createFeature(params) {
    const featureData = params.featureData;
    const type = params.type;
    const imageFileNo = params.imageFileNo;
    const name = params.name;
    const id = params.id;
    const color = params.color;
    const layerDisplayOnly = params.layerDisplayOnly;
    const anchor = params.anchor;
    const url = params.url;
    const layerClone = params.layerClone;
    const tooltip = params.tooltip;
    const label = params.label;
    const layer = params.layer;
    const layerIndex = params.layerIndex;
    const centerPoint = params.centerPoint;
    const rotation = params.rotation;
    const scale = params.scale;
    const docId = params.docId;
    const radius = params.radius;
    const circleCenter = params.circleCenter;
    const feature = this.mapFunc.mapObj.createFeatureByType(featureData.geometry.coordinates, type
      , {
          EPSG: this.mapFunc.EPSG,
          imageFileNo,
          name,
          id,
          color,
          layerDisplayOnly,
          anchor,
          url,
          layer: cloneDeep(layerClone),
          tooltip,
          point: SclMapConstantService.MAP_MARKER,
          label: label,
          layerType: layer.type,
          layerIndex,
          centerPoint,
          rotation,
          scale,
          radius,
          circleCenter
        });
    this.mapFunc.mapObj.addFeature(feature, layerIndex); // 13835 //vectorSource.addFeature(feature);
    this.addCurrentSelected(feature, docId);

    return feature;
  }
  checkGeoJsonCount(pCountGeoJson) {
    this.countGeoJson += pCountGeoJson;
    if (this.totalSearchCount === 0) {
      if (this.countGeoJson === 0) {
        console.log(`sc-address-map : No geoJson data was returned from the filer or layers filter`);
      }
    }
  }


  watchDoc(newValue) {
    if (!newValue || !this.mapFunc || !this.mapFunc.mapObj) {
      return;
    }
    if ( !isEqual(this.oldValue, newValue) ) {
      if (this.multipleSelection) {
        this.currentSelected = [];
        if (this.oldValue !== undefined || this.oldValue != null) {
          this.mapFunc.mapObj.clearAllFeaturesLayer(this.mapFunc.mapObj.layerIndexUser);
        }
        if (newValue !== undefined || newValue != null) {
            for (let i = 0; i < newValue.length; i++) {
                const fs = this.mapFunc.mapObj.getFeaturesCollectionId(newValue[i].documentId);
                if (fs.length > 0) {
                    fs.forEach((f, j) => {
                        if (f) {
                            const fClone = this.mapFunc.mapObj.featureClone(f, this.mapFunc.mapObj.layerIndexUser);
                            this.currentSelected.push(fClone);
                            this.mapFunc.mapObj.addFeature(fClone, this.mapFunc.mapObj.layerIndexUser);
                        }
                    });
                }
            }
        }
        this.mapFunc.mapObj.addInteractionSelect(this.currentSelected);
      }
    }
    this.oldValue = newValue;
  }

  watchLayers(newValue) {
    if ( !isEqual(this.oldValueLayers, newValue) ) {
      this.updateLayers(newValue);
      this.resetSearchDelay();

      this.searchDelay(0, newValue.length, newValue, this.searchAssetLayer.bind(this), false, true);
    }
    this.oldValueLayers = newValue;
  }

  updateLayers(newLayer) {
    this.mapFunc.layerAssets = [];
    let idx = 0;
    for (let i = newLayer.length - 1; i > -1; i--) {
      idx++;
      let isHeatMap = false;
      if (newLayer[i].type && newLayer[i].type === 'heatmap') { isHeatMap = true; }
      this.mapFunc.layerAssets.push({query: newLayer[i].filter + '_layer_' + idx, i: idx, isHeatMap: isHeatMap, layer: newLayer[i]});
    }
    if (this.componentDefinition.filter) {
      const filterIndex = this.mapFunc.layerAssets.length + 1;
      const filterInfo = this.sclUtilMapService.buildFilterObj(this.componentDefinition, this.addressField);
      let isHeatMap = false;
      if (this.componentDefinition.type && this.componentDefinition.type === 'heatmap') { isHeatMap = true; }
      this.mapFunc.layerAssets.push({query: this.componentDefinition.filter + '_filter_' + filterIndex, i: filterIndex
      , isHeatMap: isHeatMap, layer: filterInfo});
      this.filterLayerIndex = filterIndex;
    }
    this.mapFunc?.mapObj?.updateLayers(this.mapFunc.layerAssets);
  }
  // resetupTooltipUI() { // 15714
  //   if (this.mapFunc.mapObj.setupTooltipUI && (typeof this.mapFunc.mapObj.setupTooltipUI === 'function')) {
  //     this.setupTooltipUI();
  //     this.mapFunc.mapObj.setupTooltipUI = null; // call one time
  //   }
  // }
  // setupTooltipUI() {
  //   this.targetMapElement.insertBefore(this.mapFunc?.divInfo?.nativeElement, this.targetMapElement?.firstChild);
  //   this.targetMapElement.insertBefore(this.mapFunc?.divInfo1?.nativeElement, this.targetMapElement?.firstChild);
  // }
  clusterClick(markers, pixel) {
    if (markers.length > 1) {
      this.clusterMarkersClicked = markers;
      const htmlText = this.getHTMLClusterMarkers(markers);
      this.setPopupClusterPosition(pixel);
    } else {
      this.selectModeMultiple(markers, true);
    }
  }
  showPopupClusters() {
    this.disableTooltip();
    this.mapFunc.divInfo1.nativeElement.click();

    this.isPopupRadioOpen = true;

    const popover = this.mapFunc.divInfo1.nativeElement.querySelectorAll('div.popover')[0];
    if (popover) {
        const lst = document.querySelectorAll('[content-exp="contentExp()"]');
        if (lst != null && lst.length > 0) {
          const item: any = lst[0];
          item.style.zIndex = this.mapFunc.mapObj.layerIndexTooltips;
        }
    }
  }
  setPopupClusterPosition(pixel1) {
    if (!this.mapCenter || !this.mapCenter.x || !this.mapCenter.y) {
      this.getMapSize();
    }
    this.isRadioPopupScroll = false;
    this.radioPopupInfo.nativeElement.style.height = 'auto';

    let featureLeftPos1 = pixel1[0];
    let featureTopPos1 = pixel1[1];

    // set the tooltip position
    let tooltipHorizontalPosition1;
    let tooltipVerticalPosition1;

    if (featureLeftPos1 < this.mapCenter.x) {
        tooltipHorizontalPosition1 = 'left';
        featureLeftPos1 -= 10;
    } else {
        tooltipHorizontalPosition1 = 'right';
        featureLeftPos1 += 25;
    }

    if (featureTopPos1 < this.mapCenter.y) {
        tooltipVerticalPosition1 = 'bottom';
        featureTopPos1 += 10;
    } else {
        tooltipVerticalPosition1 = 'top';
        featureTopPos1 -= 10;
    }

    const divInfo1Pos = this.mapFunc.divInfo1.nativeElement.getBoundingClientRect();
    let tipWidth = divInfo1Pos.width; let tipHeight = divInfo1Pos.height;
    if (tipWidth === 0) { tipWidth = 200; }
    if (tipHeight === 0) { tipHeight = 200; }
    let tipPos = { left: 0, top: 0};
    if (tooltipVerticalPosition1 === 'top') {
      if (tooltipHorizontalPosition1 === 'left') {
        tipPos = {
          left: featureLeftPos1 + 1,
          top: featureTopPos1 - tipHeight + 1
        };
      } else {// right
        tipPos = {
          left: featureTopPos1 - tipWidth + 1,
          top: featureTopPos1 - tipHeight + 1
        };
      }
    } else {// bottom
      if (tooltipHorizontalPosition1 === 'left') {
        tipPos = {
          left: featureLeftPos1 + 1,
          top: featureTopPos1 + 1
        };
      } else {// right
        tipPos = {
          left: featureLeftPos1 - tipWidth + 1,
          top: featureTopPos1 + 1
        };
      }
    }

    this.infoRadioPosition.left = tipPos.left + 'px';
    this.infoRadioPosition.top = tipPos.top + 'px';

    // check overflow and update height for radio popup
    let height = this.mapHeight;
    let radioTop = tipPos.top;
    if (tipPos.top > 0) {
      height = tipPos.top + this.radioPopupInfo.nativeElement.offsetHeight;
      radioTop = tipPos.top;
    } else {
      height = pixel1[1] + this.radioPopupInfo.nativeElement.offsetHeight;
      radioTop = pixel1[1];
    }
    if (height > this.mapHeight) {
      const h = this.mapHeight - pixel1[1];
      this.radioPopupInfo.nativeElement.style.height = h + 'px';
      this.isRadioPopupScroll = true;
      this.infoRadioPosition.top = radioTop + 'px';
    }
    if (tipPos.left < 0) {
      this.infoRadioPosition.left = pixel1[0] + 'px';
    }
    this.cdRef.detectChanges();
  }

  getHTMLClusterMarkers(features) {
    if (features === undefined || features.length === 0) {
      return;
    }

    let text = '<div>';
    this.postList = [];
    let isDisplayOnly = true;
    for (let i = 0; i < features.length; i++) {
      const feature = features[i];
      const properties = this.mapFunc.mapObj.getFeatureProperties(feature, ['name', 'id', 'layerDisplayOnly', 'url']);
      const name = properties.name;
      const docId = properties.id;

      let html = '';
      if (this.multipleSelection) {
        const id = this.keyName + i + 'popup';
        const cbName = this.keyName + 'popup';
        const exist = this.getSelectedAssetById(docId);
        let check = '';
        if (exist) {
          check = 'checked';
        }
        if (!properties.layerDisplayOnly) {
          isDisplayOnly = false;
          html += '<input type=\'checkbox\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
        }
        html += name;
      } else {
        // single select mode
        let url = properties.url;
        if (url) {
          if (url.indexOf('_') > -1) {
            url = url.split('_')[0];
          }
          if (!properties.layerDisplayOnly) {
            html += '<a href = \'' + url + '\' target="_blank"><span id =  \'' + docId + '\'>' + name + '</span></a>';
          }

        } else {
          html += '<span id =  \'' + docId + '\'>' + name + '</span>';
        }
      }
      this.allowSelectAsset = isDisplayOnly;

      text += html;
      this.postList.push(html);
    }


    const htmlButton = '<button type="button" class=\'btn btn-danger\' (click)=\'closeClusterPopup(true)\'>OK</button>';
    text += htmlButton;

    text += '</div>';
    this.showPopupClusters();
    this.cdRef.detectChanges();
    return text;
  }
  getClusterClicked(id) {
    if (this.clusterMarkersClicked.length == 0) { return null; }
    for (let i = 0; i < this.clusterMarkersClicked.length; i++) {
      const fId = this.mapFunc.mapObj.getFeatureId(this.clusterMarkersClicked[i]);
      if (id === fId) {
        return this.clusterMarkersClicked[i];
      }
    }
  }
  getSelectedAssetById(id) {
    if (this.currentSelected.length === 0) { return null; }
    for (let i = 0; i < this.currentSelected.length; i++) {
      const fId = this.mapFunc.mapObj.getFeatureId(this.currentSelected[i]);
      if (id === fId) {
        return {idx: i, feature: this.currentSelected[i]};
      }
    }
  }
  closeClusterPopup(isMultiMode) {
    if (isMultiMode) {
      this.isPopupRadioOpen = false;

      const cols = [];
      let hasRemove = false;

      const id = this.keyName + 'popup';
      const cboxes = document.getElementsByName(id);
      const len = cboxes.length;
      for (let i = 0; i < len; i++) {
        const iCb = cboxes[i] as HTMLInputElement;
        let obj = this.getSelectedAssetById(iCb.value);
        if (iCb.checked) {
          if (obj == null) {
            obj = this.getClusterClicked(iCb.value);
            if (obj) {
              cols.push(obj);
            }
          }
        } else {
          if (obj) {
            hasRemove = true;
            this.mapFunc.mapObj.removeFeature(obj.feature, this.mapFunc.mapObj.layerIndexUser);
            this.currentSelected.splice(obj.idx, 1);
          }
        }
      }
      if (hasRemove && cols.length === 0) {
        this.setDirty(this.currentSelected);
      } else {
        this.selectModeMultiple(cols, true);
      }
    }
    this.isPopupRadioOpen = false;
    this.infoRadioPosition = {left: '0px', top: '0px'};
  }
  watchReadOnly() {
    this.mapFunc.setFieldActivation(this.mapFunc.targetMapElement, this.disabled, this.layerIds, false);
  }

  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    tooltip.toggle();
  }

}
